import { useMutation } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
export const urlPrefix = "/favorites";
const putFavoriteItem = async (grn) => {
  const url = `${urlPrefix}/${grn}`;
  return fetch("PUT", qualifyUrl(url));
};
const deleteFavoriteItem = (grn) => {
  const url = `${urlPrefix}/${grn}`;
  return fetch("DELETE", qualifyUrl(url));
};
const useFavoriteItemMutation = () => {
  const putMutation = useMutation({
    mutationFn: putFavoriteItem,
    onError: (errorThrown) => {
      UserNotification.error(
        `Adding item to favorites failed with status: ${errorThrown}`,
        "Could not add item to favorites"
      );
    }
  });
  const deleteMutation = useMutation({
    mutationFn: deleteFavoriteItem,
    onError: (errorThrown) => {
      UserNotification.error(
        `Deleting item from favorites failed with status: ${errorThrown}`,
        "Could not delete item from favorites"
      );
    }
  });
  return { putItem: putMutation.mutateAsync, deleteItem: deleteMutation.mutateAsync };
};
export default useFavoriteItemMutation;
